require("./lib/social");
require("./lib/ads");
// var track = require("./lib/tracking");

var $ = require("./lib/qsa");

var mountainContainer = $.one(".mountain-container");
var mountainImage = $.one(".mountain-container img");

var faceLocations = [
  [39.8, 39.4],
  [52.0, 46.4],
  [61.3, 56.7],
  [72.7, 55.8]
];

// quick hack for finding the above percentages
if (false) mountainImage.addEventListener("click", function(e) {
  var bounds = mountainImage.getBoundingClientRect();
  var { clientX, clientY } = e;
  console.log((clientX - bounds.left) / bounds.width * 100, (clientY - bounds.top) / bounds.height * 100);
});

var state = {
  dragging: false,
  offset: { x: 0, y: 0 },
  original: { x: 0, y: 0 },
  attached: [null, null, null, null]
};

var setHash = function(params) {
  var hash = Object.keys(params).map(function(k) {
    var v = params[k];
    return k + "=" + v;
  }).join(";");
  window.location.hash = hash;
};

var getHash = function() {
  var query = window.location.hash.replace("#", "");
  var params = {};
  query.split(";").map(s => {
    var [key, val] = s.split("=");
    params[key] = val;
  });
  return params;
};

// support asychronous attachment for when the image tag is cloned
var attachFace = function(img, x, y, mountainBounds) {
  var faceBounds = img.getBoundingClientRect();
  var proportional = {
    x: faceBounds.width / mountainBounds.width * 100,
    y: faceBounds.height / mountainBounds.height * 100
  };
  img.style.left = x - proportional.x * .5 + "%";
  img.style.top = y - proportional.y * .5 + "%";
};

var setFromHash = function() {
  var params = getHash();
  if (!params.faces) return;
  var indices = params.faces.split(",");
  var faces = indices.map(i => $.one(`[data-index="${i}"]`));
  var mountainBounds = mountainImage.getBoundingClientRect();

  faces.forEach(function(f, i) {
    if (!f) return;
    var [x, y] = faceLocations[i];
    var img = f.cloneNode();
    img.className = "mug attached";
    mountainContainer.appendChild(img);
    if (img.complete) attachFace(img, x, y, mountainBounds);
    img.onload = attachFace.bind(null, img, x, y, mountainBounds);
    state.attached[i] = img;
  });

};

var backdrop = $.one(".backdrop");
if (backdrop.complete) setFromHash();
backdrop.onload = setFromHash;

var startDrag = function(e) {
  e.preventDefault();
  var pointer = e.touches ? e.touches[0] : e;
  var bounds = this.getBoundingClientRect();
  state.offset.x = pointer.clientX - bounds.left;
  state.offset.y = pointer.clientY - bounds.top;
  state.original = { x: pointer.clientX, y: pointer.clientY };
  state.dragging = this;
  this.classList.add("dragging");
  ["mousemove", "touchmove"].forEach(ev => document.body.addEventListener(ev, moveDrag));
  ["mouseup", "touchend"].forEach(ev => document.body.addEventListener(ev, stopDrag));
  moveDrag(e);
};

var stopDrag = function(e) {
  var face = state.dragging;
  var mountainBounds = mountainImage.getBoundingClientRect();
  var pointer = e.changedTouches ? e.changedTouches[0] : e;

  face.classList.remove("dragging");
  face.style.left = "";
  face.style.top = "";
  state.dragging = false;

  ["mousemove", "touchmove"].forEach(ev => document.body.removeEventListener(ev, moveDrag));
  ["mouseup", "touchend"].forEach(ev => document.body.removeEventListener(ev, stopDrag));

  var dx = pointer.clientX - state.original.x;
  var dy = pointer.clientY - state.original.y;
  var distance = Math.sqrt(dx * dx + dy * dy);
  if (distance < 10) return;

  var column = (pointer.clientX - mountainBounds.left) / mountainBounds.width * 100;
  for (var i = 0; i < faceLocations.length; i++) {
    var [x, y] = faceLocations[i];
    if (Math.abs(column - x) < 5) {
      if (state.attached[i]) {
        if (state.attached[i].src == face.src) {
          // if this was an existing face, just attach it already
          return attachFace(state.attached[i], x, y, mountainBounds);
        }
        state.attached[i].parentElement.removeChild(state.attached[i]);
      }
      for (var j = 0; j < state.attached.length; j++) {
        if (state.attached[j] && state.attached[j].src == face.src) {
          state.attached[j].parentElement.removeChild(state.attached[j]);
          state.attached[j] = null;
        }
      }
      var img = face.cloneNode();
      img.className = "mug attached";
      img.onload = attachFace.bind(null, img, x, y, mountainBounds);
      mountainContainer.appendChild(img);
      state.attached[i] = img;
      break;
    }
  }

  setHash({ faces: state.attached.map(e => e ? e.getAttribute("data-index") : "").join() });
};

var moveDrag = function(e) {
  onExit();
  var element = state.dragging;
  var pointer = e.changedTouches ? e.changedTouches[0] : e;
  element.style.left = pointer.clientX - state.offset.x + "px";
  element.style.top = pointer.clientY - state.offset.y + "px";
};

var mugs = $(".mug");

["mousedown", "touchstart"].forEach(function(ev) {

  mugs.forEach(el => el.addEventListener(ev, startDrag));

  mountainContainer.addEventListener(ev, function(e) {
    if (e.target.classList.contains("mug")) startDrag.call(e.target, e);
  });

});

var lookup = {};
window.playerData.forEach(p => lookup[p.index] = p);

var tooltip = $.one(".tooltip");
var mugContainer = $.one(".mug-container");

var onHover = function(e) {
  if (state.dragging) return;
  var index = this.getAttribute("data-index");
  var data = lookup[index];
  tooltip.classList.add("show");
  tooltip.innerHTML = `
<h2>${data.name}</h2>
<h3>With the Mariners: ${data.played}</h3>
<p>${data.blurb}</p>
  `;
  var bounds = mugContainer.getBoundingClientRect();
  var tipBounds = tooltip.getBoundingClientRect();
  tooltip.style.left = e.clientX - bounds.left + "px";
  if (e.clientX > window.innerWidth / 2) {
    tooltip.style.left = e.clientX - bounds.left - tipBounds.width + "px";
  }
  tooltip.style.top = e.clientY - bounds.top - tipBounds.height - 20 + "px";
};

var onExit = function(e) {
  tooltip.classList.remove("show");
}

mugs.forEach(el => el.addEventListener("mousemove", onHover));
mugs.forEach(el => el.addEventListener("mouseout", onExit));